import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />

        <path
          d="M25 30.663h9.401l6.481 6.483v6.981L30.307 33.608l-.033 19.361H25z"
          fill="currentColor"
          transform="scale(1.30) translate(-8 -8)"
        />
        <path
          d="M48.631 52.969h-9.399l-6.48-6.484V39.501l10.575 10.517.032-19.356h5.272z"
          fill="currentColor"
          transform="scale(1.30) translate(-8 -8)"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
